import { useAppSelector } from 'dux/app/hooks';

import { Box, Text } from '@prose-ui';

import ScaleLoader from 'Components/ScaleLoader';

import { factorsContent } from 'assets/content/landingPages/skincare';

import useResponsiveVariant from 'utils/useResponsiveVariant';

import {
  getFilteredFetchedSkincareProductsIsLoaded,
  getSkincareProductsBlockContent,
} from 'dux/products/selectors';

import ProductsItem from './ProductsItem';
import SkincareConsultationCTA from './SkincareConsultationCTA';

export const SkincareProductGrid = () => {
  const { isMobile } = useResponsiveVariant({ legacy: false });

  const filteredFetchedProductsIsLoaded = useAppSelector(
    getFilteredFetchedSkincareProductsIsLoaded
  );
  const products = useAppSelector(getSkincareProductsBlockContent);

  return (
    <Box
      backgroundColor="neutral.200"
      borderBottom="1px"
      borderColor="neutral.900"
      borderLeft="1px"
      borderRight="1px"
      data-testid="skincare-lp-factors"
      display="flex"
      flexDirection="column"
      gap="15x"
      paddingY="15x"
    >
      <Text
        align={isMobile ? 'left' : 'center'}
        as="h2"
        color="primary.300"
        paddingX="6x"
        variant={isMobile ? 'heading5' : 'heading4'}
      >
        {factorsContent.catchline}
      </Text>

      <Box
        display="flex"
        flexWrap={{ mobile: 'wrap', tablet: 'nowrap' }}
        gap={{ mobile: '15x', tablet: 'none' }}
        justifyContent="center"
        paddingX={{ mobile: '6x', tablet: 'none' }}
      >
        {filteredFetchedProductsIsLoaded ? (
          products?.cards?.map(productCard => (
            <ProductsItem key={productCard.slug} content={productCard} />
          ))
        ) : (
          <ScaleLoader />
        )}
      </Box>
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        gap="5x"
        justifyContent="center"
        paddingX="6x"
      >
        <SkincareConsultationCTA noMargin />
        <Text align="center" color="primary.400" variant="bodyMd">
          {factorsContent.guarantee}
        </Text>
      </Box>
    </Box>
  );
};
